import { useState } from "react";
import { useContextDashboardContext } from "src/Contexts/Dashboard/ContextDashboardBroker";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { api } from "src/shared/setup/API/api";

export interface IValueProfitDashboard {
  data: {
    id: number;
    dateReceived: string;
    lives: number;
    commissionValue: number;
    valuePayment: number;
    installmentNumber: number;
  }[];
  totalCommissionValue: number;
}

export const UseFormEvolutionLives = () => {
  const { handleGetAlert } = useLayoutMainContext();

  const {
    filterMetricsFilterDashboard: { endDate, startDate, interval },
    setValueProfitDashboard,
  } = useContextDashboardContext();

  const [loading, setLoading] = useState(false);

  const handleCreatePerfilAcesso = async () => {
    setLoading(true);

    return api
      .get(
        `/metrics/installments-paid?startDate=${startDate}&endDate=${endDate}&interval=${interval}`
      )
      .then((res) => {
        setValueProfitDashboard(res.data.dataTransform);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoading(false));
  };

  return {
    handleSubmit: handleCreatePerfilAcesso,
    loading,
  };
};
